//import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import BarChartIcon from "@mui/icons-material/BarChart";
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import PropTypes from "prop-types";
import { downloadExcel } from "utils/exportToExcel";
import GridOnIcon from "@mui/icons-material/GridOn";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { generatePDF } from "utils/exportToPdf";
// import MDButton from "components/MDButton";
import IconButton from "@mui/material/IconButton";

function chartClic(setShowChart, showChart) {
  try {
    setShowChart(!showChart);
  } catch {
    console.log("No chart defined");
  }
}
export default function TitleCustom({ title, excelData, excelName, showChart, setShowChart }) {
  if (setShowChart === null) {
    <div>Lo sentimos no existe grafica para estos datos</div>;
  }
  return (
    <MDBox>
      <Grid container>
        <Grid item lg>
          <MDTypography variant="h6">{title}</MDTypography>
        </Grid>
        {setShowChart === null ? (
          ""
        ) : (
          <Grid item>
            {showChart ? (
              <MDBox>
                <IconButton>
                  <GridOnIcon
                    color="dark"
                    fontSize="medium"
                    onClick={() => chartClic(setShowChart, showChart)}
                  ></GridOnIcon>
                </IconButton>
              </MDBox>
            ) : (
              <MDBox>
                <IconButton>
                  <BarChartIcon
                    color="dark"
                    fontSize="medium"
                    onClick={() => chartClic(setShowChart, showChart)}
                  ></BarChartIcon>
                </IconButton>
              </MDBox>
            )}
          </Grid>
        )}
        {/* <Grid item>
          <MDBox>
            <IconButton>
              <LocalPrintshopOutlinedIcon
                color="info"
                fontSize="medium"
                onClick={() => window.print()}
              ></LocalPrintshopOutlinedIcon>
            </IconButton>
          </MDBox>
        </Grid> */}
        <Grid item>
          <MDBox>
            <IconButton>
              <ReceiptLongOutlinedIcon
                color="success"
                fontSize="medium"
                onClick={() => downloadExcel(excelData, excelName)}
              ></ReceiptLongOutlinedIcon>
            </IconButton>
          </MDBox>
        </Grid>
        <Grid item>
          <IconButton>
            <PictureAsPdfIcon
              color="primary"
              fontSize="medium"
              onClick={() => generatePDF(excelData, String(excelName).replace(".xlsx", ""))}
            ></PictureAsPdfIcon>
          </IconButton>
        </Grid>
      </Grid>
    </MDBox>
  );
}

TitleCustom.propTypes = {
  title: PropTypes.string,
  excelData: PropTypes.array,
  excelName: PropTypes.string,
  showChart: PropTypes.bool,
  setShowChart: PropTypes.any,
};

TitleCustom.defaultProps = {
  title: "Title",
  excelData: [],
  excelName: "excel.xlsx",
  showChart: false,
  setShowChart: null,
};
